/// <reference path="../../services/command.service.js" />
/// <reference path="../../services/command-execution.service.js" />
const mod = require('../../bahabot.module.js')


/**
 * @param {CommandService} CommandService
 */
function bbCommandsController(CommandService, CommandGroupService, CommandGroupAssignmentService, $location, $filter) {
    this.data = {
        commands: [],
        commandGroups: [],
        runInfo: {},
        
        assignmentType: 'existing',
        assignmentError: null,
        assignmentSaving: false,
        assignmentModal: {
            command: null,
            group: {
                id: undefined,
                name: undefined,
            }
        },

        grouped: {},
        collapsedGroups: {}
    };

    this.cmdSvc = CommandService;
    this.cmdGrpSvc = CommandGroupService;
    this.cmdGrpAsgn = CommandGroupAssignmentService;

    try {
        const savedState = localStorage.getItem('bahabot_collapsed_groups');
        if (savedState) {
            this.data.collapsedGroups = JSON.parse(savedState);
        }
    } catch (e) {
        console.warn("Could not load group visibility state", e);
    }



    this.loading = true;    

    this.cmdSvc.get()
        .then(r => {
            this.data.commands = r.cmds;
            this.data.runInfo = r.runInfo;
            this.buildGroupedCommands();
        }).finally(() => {
            this.loading = false;
        })

    this.data.commandGroups = CommandGroupService.query();
    this.data.commandGroups.$promise.then(() => {
        this.buildGroupedCommands();
    })

    this.go = function(path) {
        $location.path(path);
    }

    this.buildGroupedCommands = function() {
        if (!this.data.commands) return [];

        const groups = {};

        for (const grp of this.data.commandGroups) {
            groups[grp.id] = { name: grp.name, commands: [] };
        }

        groups["ungrouped"] = { name: "Ungrouped", commands: [] };

        for (const cmd of this.data.commands) {
            const groupId = cmd.userCommandGroupId ?? 'ungrouped';

            if (groups[groupId]) {
                groups[groupId].commands.push(cmd);
            } else {
                groups['ungrouped'].commands.push(cmd);
            }
        }

        // prune any with 0 commands
        const keys = Object.keys(groups);

        for (const key of keys) {
            if (!groups[key].commands.length) {
                delete groups[key];
            }
        }

        this.data.grouped = groups;
    }

    this.viewCommand = function(cmdId) {
        $location.path(`/dashboard/commands/edit/${cmdId}`);
    }

    this.viewCommandExecutions = function(cmdId) {
        $location.path(`/dashboard/commands/executions/${cmdId}`);
    }

    this.getPredictedRuns = function(cmd) {
        if (!this.data.runInfo[cmd.id]) return '';
        const runs = this.data.runInfo[cmd.id].map(r => $filter('date')(new Date(r), 'yyyy-MM-dd HH:mm:ss'));

        return ` Next predicted runs: ${runs.join(', ')}`;
    }

    this.saveGroupAssignment = function() {
        this.data.assignmentSaving = true;

        if (this.data.assignmentType === 'new') {
            this.cmdGrpSvc.save({
                name: this.data.assignmentModal.group.name
            }).$promise.then((d) => {
                this.data.commandGroups.push(d);

                return this.cmdGrpAsgn.assign({
                    commandId: this.data.assignmentModal.command.id,
                    commandGroupId: d.id,
                }).$promise
            }).then((d) => {
                // update in place
                const cmd = this.data.commands.find(cmd => cmd.id === d.command.id)
                if (cmd) {
                    cmd.userCommandGroupId = d.commandGroup.id;
                }

                this.buildGroupedCommands();
                this.data.assignmentModal.command = null;
            }).catch((e) => {
                console.error(e);
                this.data.assignmentError = e.data.error;
            }).finally(() => {
                this.data.assignmentSaving = false;
            })
        } else if (this.data.assignmentType === 'existing') {
            // throw error if no id given
            if (this.data.assignmentModal.group.id === "") {
                this.data.assignmentError = "invalid group selected"
                return
            }

            this.cmdGrpAsgn.assign({
                commandId: this.data.assignmentModal.command.id,
                commandGroupId: this.data.assignmentModal.group.id,
            }).$promise.then((d) => {
                const cmd = this.data.commands.find(cmd => cmd.id === d.command.id)
                if (cmd) {
                    cmd.userCommandGroupId = d.commandGroup.id;
                }
                this.buildGroupedCommands();
                this.data.assignmentModal.command = null;
            }).catch((e) => {
                console.error(e);
                this.data.assignmentError = e.data.error;
            }).finally(() => {
                this.data.assignmentSaving = false;
            })
        } else if (this.data.assignmentType === 'unassign') {
            this.cmdGrpAsgn.unassign({
                commandId: this.data.assignmentModal.command.id,
            }).$promise.then((d) => {
                const cmd = this.data.commands.find(cmd => cmd.id === this.data.assignmentModal.command.id)
                if (cmd) {
                    cmd.userCommandGroupId = null;
                }
                this.buildGroupedCommands();
                this.data.assignmentModal.command = null;
            }).catch((e) => {
                console.error(e);
                this.data.assignmentError = e.data.error;
            }).finally(() => {
                this.data.assignmentSaving = false;
            })
        }
    }

    this.viewGroupAssignment = function(cmd) {
        this.data.isNewGroup = false;
        this.data.assignmentType = 'existing';
        this.data.assignmentModal.command = cmd;
        this.data.assignmentModal.group = { id: '', name: '' };
        this.data.assignmentError = null;
    };

    this.cancelGroupAssignment = function() {
        this.data.assignmentModal.command = null;
    }

    this.viewGroupAssignmentCanSave = function() {
        if (this.data.assignmentType === 'new') {
            return !!this.data.assignmentModal.group.name
        } else if (this.data.assignmentType === 'existing') {
            return !!this.data.assignmentModal.group.id
        } else if (this.data.assignmentType === 'unassign') {
            return true;
        }
    }

    this.toggleGroupCollapsed = function(groupId) {
        this.data.collapsedGroups[groupId] = !this.data.collapsedGroups[groupId];
        localStorage.setItem('bahabot_collapsed_groups', JSON.stringify(this.data.collapsedGroups));
    };

    this.hasCommands = (group) => {
        return this.data.commands.find(cmd => cmd.userCommandGroupId === group.id);
    }
}

mod.component('bbCommands', {
    templateUrl: 'tpl/bb-commands.component.html',
    bindings: {},
    controller: ["CommandService", "CommandGroupService", "CommandGroupAssignmentService", "$location", "$filter", bbCommandsController]
});